import { forwardRef, useEffect, useRef } from 'react';

const useEnsureRef = (forwardedRef) => {
	const ref = useRef(forwardedRef && forwardedRef.current);

	useEffect(() => {
		if (!forwardedRef) {
			return;
		}
		forwardedRef.current = ref.current;
	}, [forwardedRef]);
	return ref;
};

export const forwardEnsuredRef = (Component) => {
	return forwardRef((props, ref) => {
		const safeRef = useEnsureRef(ref);
		return Component(props, safeRef);
	});
};

export default useEnsureRef;
